// Kleuren en logo van de Full Frame Assistent — dezelfde tokens als de rest van de site
// (styles/theme.js, policies/ff-design.md §Tokens). Eén plek, zodat drawer, berichten en
// typindicator niet elk hun eigen MUI-standaardgrijs of -rood kiezen (wiki-feedback 26 sep 2026).
export const AT = {
  primary: '#526075',
  primaryDim: '#465469',
  surface: '#ffffff',
  surfaceLow: '#f1f4f5',
  surfaceHigh: '#e5e9eb',
  bg: '#f8f9fa',
  text: '#2d3335',
  secondary: '#556071',
  outlineVariant: '#adb3b5',
  line: 'rgba(45, 51, 53, 0.08)',
  font: '"Manrope", system-ui, sans-serif',
};

export const FF_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/favicon-192.png`;
